import { connect } from 'react-redux';
import { IDataStorage } from '../../../core';
import { FxTranslate } from '../../../core/translate';
import { ICardEdit } from '../../../services/operaciones/model/ICardEdit';
import { Secciones } from '../index.service';
import styles from './index.module.scss';
import { Forms } from '../..';

export type IProps = {
  storage: IDataStorage;
  t: FxTranslate;

  data?: ICardEdit | null | undefined;

  onUpdateFields: (updates: { field: string, value: any }[]) => void;
}

function CardSeccionComisiones({ storage, t,
  data,
  onUpdateFields,
} : IProps) {
  const onUpdateField = (field: string, value: any) => onUpdateFields([ { field, value }]);

  return <div className={styles["card-seccion-content"]}>
    <div className={styles["card-seccion-title"]}>{t(`Menu.${Secciones.Comisiones}`)}</div>
  
    <div className='p-grid'>
      <div className='p-col-12 p-lg-6 p-p-2'>
        <Forms.Calendar 
          title={t("Seccion.Field.operacionfacturacion.liquidacionFecha")}
          className={styles["fix-form-component"]}
          value={data?.operacionfacturacion?.liquidacionfecha ? new Date(data?.operacionfacturacion?.liquidacionfecha) : undefined}
          onChange={(v,e) => onUpdateField('operacionfacturacion.liquidacionFecha', v)}
        />
      </div>
      <div className='p-col-12 p-lg-6 p-p-2'>
        <Forms.UploadSingleFile 
          title={t("Seccion.Field.operacionfacturacion.liquidacionArchivoDTO")}
          className={styles["fix-form-component"]}
          hideDelete
          value={data?.operacionfacturacion?.liquidacionArchivoDTO}
          onChange={(v,e) => onUpdateField('operacionfacturacion.liquidacionArchivoDTO', v)}
        />
      </div>
      <div className='p-col-12 p-lg-6 p-p-2'>
        <Forms.Input 
          title={t("Seccion.Field.operacionfacturacion.facturaComisionNumero")}
          className={styles["fix-form-component"]}
          value={data?.operacionfacturacion?.facturacomisionnumero}
          onChange={(v,e) => onUpdateField('operacionfacturacion.facturaComisionNumero', v)}
        />
      </div>
      <div className='p-col-12 p-lg-6 p-p-2'>
        <Forms.UploadSingleFile 
          title={t("Seccion.Field.operacionfacturacion.facturaComisionArchivo")}
          className={styles["fix-form-component"]}
          hideDelete
          value={data?.operacionfacturacion?.facturaComisionArchivoDTO}
          onChange={(v,e) => onUpdateField('operacionfacturacion.facturaComisionArchivoDTO', v)}
        />
      </div>
    </div>
  </div>;
}
export default connect((s:any) => ({ storage:s.main }))(CardSeccionComisiones);
